import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Breadcrumb() {
  const location = useLocation();
  const pathParts = location.pathname.split('/').filter(Boolean);

  if (pathParts.length === 0) return null;

  const breadcrumbs: { label: string; href: string }[] = [
    { label: '首页', href: '/' },
  ];

  if (pathParts[0] === 'category' && pathParts[1]) {
    const cat = categories.find((c) => c.slug === pathParts[1]);
    breadcrumbs.push({
      label: cat ? cat.name : '分类',
      href: `/category/${pathParts[1]}`,
    });
  }

  if (pathParts[0] === 'detail' && pathParts[1]) {
    breadcrumbs.push({
      label: '影视详情',
      href: location.pathname,
    });
  }

  if (pathParts[0] === 'about') {
    breadcrumbs.push({
      label: '关于我们',
      href: '/about',
    });
  }

  return (
    <nav aria-label="breadcrumb" className="w-full px-4 md:px-6 py-3">
      <ol className="flex items-center flex-wrap gap-1 text-sm" itemScope itemType="https://schema.org/BreadcrumbList">
        {breadcrumbs.map((crumb, index) => (
          <li key={crumb.href} className="flex items-center gap-1" itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
            {index > 0 && (
              <span className="text-foreground-400 mx-1">/</span>
            )}
            {index < breadcrumbs.length - 1 ? (
              <Link
                to={crumb.href}
                className="text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap"
                itemProp="item"
              >
                <span itemProp="name">{crumb.label}</span>
              </Link>
            ) : (
              <span className="text-foreground-800 font-medium whitespace-nowrap" itemProp="name">
                {crumb.label}
              </span>
            )}
            <meta itemProp="position" content={String(index + 1)} />
          </li>
        ))}
      </ol>
    </nav>
  );
}